// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__H4qs1 {
    --icon-color-custom: var(--light-grey);

    position: relative;

    width: var(--box-width);
    min-width: var(--box-width);
    height: var(--box-height);
    min-height: var(--box-height);

    color: var(--light-grey);
    background: #fff;
    transition:
        margin 0.4s,
        background-color 0.4s,
        border 0.4s,
        color 0.4s,
        width 0.4s,
        height 0.4s,
        transform 0.4s;
}

.styles_container__H4qs1 * {
    transition: opacity 0.4s;
}

.styles_container__H4qs1 p {
    margin: 2px 0;
    font-size: 14px;
    font-style: italic;
    font-weight: 100;
    text-align: center;
}

.styles_container__H4qs1:not(.styles_open__1CS\\+j):nth-child(6) ~ .styles_container__H4qs1 {
    display: none;
}

.styles_innerBox__jnqli {
    width: 100%;
    height: 100%;
    padding: 19px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.styles_secondary__pcCPM {
    align-items: center;
}

.styles_secondary__pcCPM h6 {
    text-transform: initial;
}

.styles_secondary__pcCPM h6:first-child {
    text-transform: capitalize;
}

.styles_secondary__pcCPM h6 {
    font-size: 14px;
    margin-bottom: 4px;
    color: #000000;
}

.styles_box__oLKNr {
    border: 2px dashed var(--light-grey);
    cursor: pointer;
    opacity: 1;

    --icon-stroke: 1px;
}

.styles_box__oLKNr.styles_disabled__48Co-
/*.box.secondary:not(.selected) */ {
    border: 1px dashed var(--light-grey) !important;
    color: var(--light-grey) !important;
    background-color: #ffffff !important;
    --icon-color-custom: var(--light-grey) !important;
}

.styles_box__oLKNr.styles_disabled__48Co-,
.styles_box__oLKNr.styles_disabled__48Co- ~ * {
    pointer-events: none;
    cursor: initial;
}

.styles_container__H4qs1.styles_active__7pg4D {
    --icon-color-custom: var(--primary-color);

    border: 0.5px solid var(--primary-color);
    color: var(--primary-color);
}

.styles_box__oLKNr:first-child {
    position: relative;
    z-index: 10;
}

.styles_box__oLKNr.styles_horizontal__oyEUh:not(:first-child) {
    --margin-offset: -4px;
    --margin-left: calc((var(--box-width) - var(--margin-offset)) * -1);
}

.styles_box__oLKNr.styles_horizontal__oyEUh:nth-child(2):not(.styles_open__1CS\\+j) {
    --margin-top: var(--margin-offset);
    z-index: 8;
}

.styles_box__oLKNr.styles_horizontal__oyEUh:nth-child(3) {
    --margin-top: calc(var(--margin-offset) * 2);
    z-index: 6;
}

.styles_box__oLKNr.styles_horizontal__oyEUh:nth-child(4) {
    --margin-top: calc(var(--margin-offset) * 3);
    z-index: 4;
}

.styles_box__oLKNr.styles_horizontal__oyEUh:nth-child(5) {
    --margin-top: calc(var(--margin-offset) * 4);
    z-index: 2;
}

.styles_box__oLKNr.styles_horizontal__oyEUh:nth-child(6) {
    --margin-top: calc(var(--margin-offset) * 5);
    z-index: 1;
}

.styles_box__oLKNr:nth-child(6) ~ * {
    opacity: 0;
}

.styles_box__oLKNr.styles_vertical__XnSt6:nth-child(1):not(.styles_open__1CS\\+j) ~ .styles_box__oLKNr {
    --margin-offset: -4px;
    --margin-top: calc((var(--box-height) - var(--margin-offset)) * -1);
}

.styles_box__oLKNr.styles_vertical__XnSt6:nth-child(2):not(.styles_open__1CS\\+j) {
    --margin-left: calc(var(--margin-offset) * 2);
    z-index: 8;
}

.styles_box__oLKNr.styles_vertical__XnSt6:nth-child(3) {
    --margin-left: calc(var(--margin-offset) * 4);
    z-index: 6;
}

.styles_box__oLKNr.styles_vertical__XnSt6:nth-child(4) {
    --margin-left: calc(var(--margin-offset) * 6);
    z-index: 4;
}

.styles_box__oLKNr.styles_vertical__XnSt6:nth-child(5) {
    --margin-left: calc(var(--margin-offset) * 8);
    z-index: 2;
}

.styles_box__oLKNr.styles_vertical__XnSt6:nth-child(6) {
    --margin-left: calc(var(--margin-offset) * 10);
    z-index: 1;
}

.styles_box__oLKNr.styles_selected__wsqhu {
    border: 1px solid var(--primary-color);

    /*height: 107px;*/
    /*min-height: 107px;*/
    /*width:  225px;*/
    /*--box-width: 225px;*/
    /*--box-height: 107px;*/
    /*--box-width: clamp(150px, 10vw, 225px);*/
    /*--box-height: clamp(70px, 5vw, 107px);*/
}

.styles_box__oLKNr.styles_selected__wsqhu:not(.styles_disabled__48Co-) {
    --icon-fill-color-custom: var(--primary-color-light);
}

.styles_box__oLKNr.styles_selected__wsqhu.styles_secondary__pcCPM {
    background: var(--primary-color-light);
    color: #000000;
}

.styles_box__oLKNr.styles_selected__wsqhu.styles_primary__xP7qj {
    background: var(--primary-color-light);
    /*border: 0.5px solid var(--primary-color);*/
    color: var(--primary-color);
    --icon-color-custom: var(--primary-color);
}

.styles_box__oLKNr.styles_selected__wsqhu.styles_primary__xP7qj.styles_open__1CS\\+j {
    background: #fff;
}

.styles_box__oLKNr.styles_selected__wsqhu.styles_secondary__pcCPM p {
    color: #000;
    font-size: 12px;
    font-weight: 300;
}

.styles_box__oLKNr.styles_horizontal__oyEUh.styles_open__1CS\\+j {
    /*width: 170px;*/
    /*height: 75px;*/
    /*min-height: 75px;*/
}

.styles_box__oLKNr.styles_vertical__XnSt6.styles_open__1CS\\+j,
.styles_smaller__wy-u9 {
    /*width: 200px;*/
    /*height: 90px;*/
    /*min-height: 90px;*/
    /*width: 90%;*/
    /*height: 90%;*/

    /*min-width: 90%;*/
    /*min-height: 90%;*/
    /*max-height: 90%;*/

    /*border: 0.5px solid var(--primary-color);*/
    color: var(--primary-color);
    --icon-color-custom: var(--primary-color);
}

.styles_smaller__wy-u9 {
    /*margin-left: 26px !important;*/
}

.styles_box__oLKNr.styles_selected__wsqhu:not(.styles_open__1CS\\+j):not(:first-child) * {
    opacity: 0;
}

.styles_triangle__QpJ3E.styles_selected__wsqhu {
    /*border: 0;*/
    /*width: 202px;*/
    /*padding-top: 46px;*/
}

.styles_triangle__QpJ3E.styles_selected__wsqhu * {
    /*position: relative;*/
    /*color: #fff;*/
}

.styles_triangle__QpJ3E.styles_selected__wsqhu:before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 87px solid transparent;
    border-right: 87px solid transparent;
    border-bottom: 87px solid #fff;
    top: 10px;
    left: 0;
    right: 0;
    margin: auto;
    z-index: -1;
}

.styles_open__1CS\\+j {
    margin: auto;
}

.styles_box__oLKNr:not(.styles_open__1CS\\+j) {
    margin-left: var(--margin-left, 0);
    margin-top: var(--margin-top, 0);
}

.styles_box__oLKNr.styles_open__1CS\\+j {
    margin-left: 7px;
    margin-right: 7px;
    margin-top: 7px;
}

/*.box.open.primary.vertical {*/
/*    min-height: 0;*/
/*    max-height: 0;*/
/*}*/

.styles_box__oLKNr.styles_open__1CS\\+j.styles_primary__xP7qj.styles_horizontal__oyEUh {
    min-width: 0;
    max-width: 0;
}

.styles_box__oLKNr:nth-child(6) ~ * {
    opacity: 1;
}

.styles_hidden__koNLT {
    opacity: 0;
}

.styles_row__RyKRU {
    display: grid;
    align-items: center;
    grid-gap: 10px;
    grid-template-columns: 37px 1fr;
}

.styles_box__oLKNr {
    position: initial;
}

.styles_box__oLKNr.styles_primary__xP7qj.styles_open__1CS\\+j:not(.styles_triangle__QpJ3E) .styles_innerBox__jnqli {
    opacity: 0;
}

.styles_box__oLKNr.styles_primary__xP7qj.styles_open__1CS\\+j:not(.styles_triangle__QpJ3E) {
    background: transparent;
    border-color: transparent;
    pointer-events: none;
}

.styles_openPlaceholder__IlR4j {
    position: absolute;
    opacity: 0;
    /*top: -60px;*/
    top: calc(var(--box-height) * -1 + 20px);

    display: flex;
    align-items: center;
    grid-gap: 10px;
    --icon-color-custom: #000;
    color: #000000;
    font-weight: 300;
}

.styles_vertical__XnSt6.styles_open__1CS\\+j .styles_openPlaceholder__IlR4j {
    /*top: 40px;*/
    top: calc(var(--box-height) / 3);
}

.styles_horizontal__oyEUh.styles_open__1CS\\+j .styles_openPlaceholder__IlR4j {
    left: calc(100% + 16px);
}

.styles_box__oLKNr.styles_open__1CS\\+j .styles_openPlaceholder__IlR4j {
    opacity: 1;
    transition-delay: 0.4s;
}

.styles_absolute__jk-Pm {
    position: absolute;
}

.styles_isBottom__uHUbv {
    align-content: flex-end;
}

.styles_main__94UgV h6 {
    font-weight: 400;
}

.styles_main__94UgV h6,
.styles_main__94UgV p {
    color: #000;
    text-align: center;
}

.styles_main__94UgV p {
    font-weight: 300;
}

.styles_minor__Ef5Nk.styles_primary__xP7qj h6 {
    font-weight: 500;
    font-size: 16px;
    /*margin-bottom: 4px;*/
}

.styles_main__94UgV .styles_innerBox__jnqli h6 {
    font-size: 16px;
    /*margin-bottom: 4px;*/
}

.styles_main__94UgV p {
    font-size: 14px;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_box__oLKNr {
        /*--box-width: 150px !important;*/
        /*--box-height: 70px !important;*/
        /*width: 150px !important;*/
        /*min-width: 150px !important;*/
        /*height: 70px !important;*/
        /*min-height: 70px !important;*/
        --icon-stroke: 0.75px;
    }

    .styles_box__oLKNr.styles_selected__wsqhu {
        border-width: 0.75px;
    }

    .styles_triangle__QpJ3E.styles_selected__wsqhu:before {
        /*border-left: 67px solid transparent;*/
        /*border-right: 67px solid transparent;*/
        border-bottom: 50px solid #fff;
        border-left-width: 67px;
        border-right-width: 67px;
        /*top: 10px;*/
    }

    .styles_vertical__XnSt6.styles_open__1CS\\+j .styles_openPlaceholder__IlR4j {
        /*top: 40px;*/
        top: calc(var(--box-height) - 40px);
    }

    /*.row {*/
    /*    grid-template-columns: 25px 1fr;*/
    /*}*/

    .styles_innerBox__jnqli {
        padding: 10px 6px;
    }

    /*.main p {*/
    /*    font-size: 12px;*/
    /*}*/

    .styles_minor__Ef5Nk.styles_primary__xP7qj h6 {
        font-size: 13px;
    }
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-sm-max"]} {
    .styles_row__RyKRU {
        grid-template-columns: 25px 1fr;
    }

    .styles_minor__Ef5Nk.styles_primary__xP7qj h6 {
        font-size: 12px;
    }

    .styles_main__94UgV .styles_innerBox__jnqli h6 {
        font-size: 14px;
    }

    .styles_main__94UgV p {
        font-size: 12px;
    }

    .styles_minor__Ef5Nk.styles_primary__xP7qj h6 {
        font-size: 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Storage/StorageView/StorageMainViews/components/StorageBoxSingle/styles.module.css"],"names":[],"mappings":"AAEA;IACI,sCAAsC;;IAEtC,kBAAkB;;IAElB,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;IACzB,6BAA6B;;IAE7B,wBAAwB;IACxB,gBAAgB;IAChB;;;;;;;sBAOkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,UAAU;;IAEV,kBAAkB;AACtB;;AAEA;;IAEI,+CAA+C;IAC/C,mCAAmC;IACnC,oCAAoC;IACpC,iDAAiD;AACrD;;AAEA;;IAEI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,yCAAyC;;IAEzC,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,mEAAmE;AACvE;;AAEA;IACI,kCAAkC;IAClC,UAAU;AACd;;AAEA;IACI,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,mEAAmE;AACvE;;AAEA;IACI,6CAA6C;IAC7C,UAAU;AACd;;AAEA;IACI,6CAA6C;IAC7C,UAAU;AACd;;AAEA;IACI,6CAA6C;IAC7C,UAAU;AACd;;AAEA;IACI,6CAA6C;IAC7C,UAAU;AACd;;AAEA;IACI,8CAA8C;IAC9C,UAAU;AACd;;AAEA;IACI,sCAAsC;;IAEtC,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,0CAA0C;IAC1C,yCAAyC;AAC7C;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,4CAA4C;IAC5C,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd,eAAe;;IAEf,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;;IAEnB,4CAA4C;IAC5C,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,8BAA8B;IAC9B,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA,+BAA+B;AAC/B,qBAAqB;AACrB,qBAAqB;AACrB,IAAI;;AAEJ;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,wCAAwC;;IAExC,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,iCAAiC;QACjC,iCAAiC;QACjC,2BAA2B;QAC3B,+BAA+B;QAC/B,2BAA2B;QAC3B,+BAA+B;QAC/B,qBAAqB;IACzB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,uCAAuC;QACvC,wCAAwC;QACxC,8BAA8B;QAC9B,uBAAuB;QACvB,wBAAwB;QACxB,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,mCAAmC;IACvC;;IAEA,SAAS;IACT,uCAAuC;IACvC,IAAI;;IAEJ;QACI,iBAAiB;IACrB;;IAEA,YAAY;IACZ,uBAAuB;IACvB,IAAI;;IAEJ;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["@value screen-md-max, screen-sm-max from '../../../../../../breakpoints.css';\n\n.container {\n    --icon-color-custom: var(--light-grey);\n\n    position: relative;\n\n    width: var(--box-width);\n    min-width: var(--box-width);\n    height: var(--box-height);\n    min-height: var(--box-height);\n\n    color: var(--light-grey);\n    background: #fff;\n    transition:\n        margin 0.4s,\n        background-color 0.4s,\n        border 0.4s,\n        color 0.4s,\n        width 0.4s,\n        height 0.4s,\n        transform 0.4s;\n}\n\n.container * {\n    transition: opacity 0.4s;\n}\n\n.container p {\n    margin: 2px 0;\n    font-size: 14px;\n    font-style: italic;\n    font-weight: 100;\n    text-align: center;\n}\n\n.container:not(.open):nth-child(6) ~ .container {\n    display: none;\n}\n\n.innerBox {\n    width: 100%;\n    height: 100%;\n    padding: 19px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.secondary {\n    align-items: center;\n}\n\n.secondary h6 {\n    text-transform: initial;\n}\n\n.secondary h6:first-child {\n    text-transform: capitalize;\n}\n\n.secondary h6 {\n    font-size: 14px;\n    margin-bottom: 4px;\n    color: #000000;\n}\n\n.box {\n    border: 2px dashed var(--light-grey);\n    cursor: pointer;\n    opacity: 1;\n\n    --icon-stroke: 1px;\n}\n\n.box.disabled\n/*.box.secondary:not(.selected) */ {\n    border: 1px dashed var(--light-grey) !important;\n    color: var(--light-grey) !important;\n    background-color: #ffffff !important;\n    --icon-color-custom: var(--light-grey) !important;\n}\n\n.box.disabled,\n.box.disabled ~ * {\n    pointer-events: none;\n    cursor: initial;\n}\n\n.container.active {\n    --icon-color-custom: var(--primary-color);\n\n    border: 0.5px solid var(--primary-color);\n    color: var(--primary-color);\n}\n\n.box:first-child {\n    position: relative;\n    z-index: 10;\n}\n\n.box.horizontal:not(:first-child) {\n    --margin-offset: -4px;\n    --margin-left: calc((var(--box-width) - var(--margin-offset)) * -1);\n}\n\n.box.horizontal:nth-child(2):not(.open) {\n    --margin-top: var(--margin-offset);\n    z-index: 8;\n}\n\n.box.horizontal:nth-child(3) {\n    --margin-top: calc(var(--margin-offset) * 2);\n    z-index: 6;\n}\n\n.box.horizontal:nth-child(4) {\n    --margin-top: calc(var(--margin-offset) * 3);\n    z-index: 4;\n}\n\n.box.horizontal:nth-child(5) {\n    --margin-top: calc(var(--margin-offset) * 4);\n    z-index: 2;\n}\n\n.box.horizontal:nth-child(6) {\n    --margin-top: calc(var(--margin-offset) * 5);\n    z-index: 1;\n}\n\n.box:nth-child(6) ~ * {\n    opacity: 0;\n}\n\n.box.vertical:nth-child(1):not(.open) ~ .box {\n    --margin-offset: -4px;\n    --margin-top: calc((var(--box-height) - var(--margin-offset)) * -1);\n}\n\n.box.vertical:nth-child(2):not(.open) {\n    --margin-left: calc(var(--margin-offset) * 2);\n    z-index: 8;\n}\n\n.box.vertical:nth-child(3) {\n    --margin-left: calc(var(--margin-offset) * 4);\n    z-index: 6;\n}\n\n.box.vertical:nth-child(4) {\n    --margin-left: calc(var(--margin-offset) * 6);\n    z-index: 4;\n}\n\n.box.vertical:nth-child(5) {\n    --margin-left: calc(var(--margin-offset) * 8);\n    z-index: 2;\n}\n\n.box.vertical:nth-child(6) {\n    --margin-left: calc(var(--margin-offset) * 10);\n    z-index: 1;\n}\n\n.box.selected {\n    border: 1px solid var(--primary-color);\n\n    /*height: 107px;*/\n    /*min-height: 107px;*/\n    /*width:  225px;*/\n    /*--box-width: 225px;*/\n    /*--box-height: 107px;*/\n    /*--box-width: clamp(150px, 10vw, 225px);*/\n    /*--box-height: clamp(70px, 5vw, 107px);*/\n}\n\n.box.selected:not(.disabled) {\n    --icon-fill-color-custom: var(--primary-color-light);\n}\n\n.box.selected.secondary {\n    background: var(--primary-color-light);\n    color: #000000;\n}\n\n.box.selected.primary {\n    background: var(--primary-color-light);\n    /*border: 0.5px solid var(--primary-color);*/\n    color: var(--primary-color);\n    --icon-color-custom: var(--primary-color);\n}\n\n.box.selected.primary.open {\n    background: #fff;\n}\n\n.box.selected.secondary p {\n    color: #000;\n    font-size: 12px;\n    font-weight: 300;\n}\n\n.box.horizontal.open {\n    /*width: 170px;*/\n    /*height: 75px;*/\n    /*min-height: 75px;*/\n}\n\n.box.vertical.open,\n.smaller {\n    /*width: 200px;*/\n    /*height: 90px;*/\n    /*min-height: 90px;*/\n    /*width: 90%;*/\n    /*height: 90%;*/\n\n    /*min-width: 90%;*/\n    /*min-height: 90%;*/\n    /*max-height: 90%;*/\n\n    /*border: 0.5px solid var(--primary-color);*/\n    color: var(--primary-color);\n    --icon-color-custom: var(--primary-color);\n}\n\n.smaller {\n    /*margin-left: 26px !important;*/\n}\n\n.box.selected:not(.open):not(:first-child) * {\n    opacity: 0;\n}\n\n.triangle.selected {\n    /*border: 0;*/\n    /*width: 202px;*/\n    /*padding-top: 46px;*/\n}\n\n.triangle.selected * {\n    /*position: relative;*/\n    /*color: #fff;*/\n}\n\n.triangle.selected:before {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-left: 87px solid transparent;\n    border-right: 87px solid transparent;\n    border-bottom: 87px solid #fff;\n    top: 10px;\n    left: 0;\n    right: 0;\n    margin: auto;\n    z-index: -1;\n}\n\n.open {\n    margin: auto;\n}\n\n.box:not(.open) {\n    margin-left: var(--margin-left, 0);\n    margin-top: var(--margin-top, 0);\n}\n\n.box.open {\n    margin-left: 7px;\n    margin-right: 7px;\n    margin-top: 7px;\n}\n\n/*.box.open.primary.vertical {*/\n/*    min-height: 0;*/\n/*    max-height: 0;*/\n/*}*/\n\n.box.open.primary.horizontal {\n    min-width: 0;\n    max-width: 0;\n}\n\n.box:nth-child(6) ~ * {\n    opacity: 1;\n}\n\n.hidden {\n    opacity: 0;\n}\n\n.row {\n    display: grid;\n    align-items: center;\n    grid-gap: 10px;\n    grid-template-columns: 37px 1fr;\n}\n\n.box {\n    position: initial;\n}\n\n.box.primary.open:not(.triangle) .innerBox {\n    opacity: 0;\n}\n\n.box.primary.open:not(.triangle) {\n    background: transparent;\n    border-color: transparent;\n    pointer-events: none;\n}\n\n.openPlaceholder {\n    position: absolute;\n    opacity: 0;\n    /*top: -60px;*/\n    top: calc(var(--box-height) * -1 + 20px);\n\n    display: flex;\n    align-items: center;\n    grid-gap: 10px;\n    --icon-color-custom: #000;\n    color: #000000;\n    font-weight: 300;\n}\n\n.vertical.open .openPlaceholder {\n    /*top: 40px;*/\n    top: calc(var(--box-height) / 3);\n}\n\n.horizontal.open .openPlaceholder {\n    left: calc(100% + 16px);\n}\n\n.box.open .openPlaceholder {\n    opacity: 1;\n    transition-delay: 0.4s;\n}\n\n.absolute {\n    position: absolute;\n}\n\n.isBottom {\n    align-content: flex-end;\n}\n\n.main h6 {\n    font-weight: 400;\n}\n\n.main h6,\n.main p {\n    color: #000;\n    text-align: center;\n}\n\n.main p {\n    font-weight: 300;\n}\n\n.minor.primary h6 {\n    font-weight: 500;\n    font-size: 16px;\n    /*margin-bottom: 4px;*/\n}\n\n.main .innerBox h6 {\n    font-size: 16px;\n    /*margin-bottom: 4px;*/\n}\n\n.main p {\n    font-size: 14px;\n}\n\n@media screen-md-max {\n    .box {\n        /*--box-width: 150px !important;*/\n        /*--box-height: 70px !important;*/\n        /*width: 150px !important;*/\n        /*min-width: 150px !important;*/\n        /*height: 70px !important;*/\n        /*min-height: 70px !important;*/\n        --icon-stroke: 0.75px;\n    }\n\n    .box.selected {\n        border-width: 0.75px;\n    }\n\n    .triangle.selected:before {\n        /*border-left: 67px solid transparent;*/\n        /*border-right: 67px solid transparent;*/\n        border-bottom: 50px solid #fff;\n        border-left-width: 67px;\n        border-right-width: 67px;\n        /*top: 10px;*/\n    }\n\n    .vertical.open .openPlaceholder {\n        /*top: 40px;*/\n        top: calc(var(--box-height) - 40px);\n    }\n\n    /*.row {*/\n    /*    grid-template-columns: 25px 1fr;*/\n    /*}*/\n\n    .innerBox {\n        padding: 10px 6px;\n    }\n\n    /*.main p {*/\n    /*    font-size: 12px;*/\n    /*}*/\n\n    .minor.primary h6 {\n        font-size: 13px;\n    }\n}\n\n@media screen-sm-max {\n    .row {\n        grid-template-columns: 25px 1fr;\n    }\n\n    .minor.primary h6 {\n        font-size: 12px;\n    }\n\n    .main .innerBox h6 {\n        font-size: 14px;\n    }\n\n    .main p {\n        font-size: 12px;\n    }\n\n    .minor.primary h6 {\n        font-size: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"screen-sm-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-sm-max"]}`,
	"container": `styles_container__H4qs1`,
	"open": `styles_open__1CS+j`,
	"innerBox": `styles_innerBox__jnqli`,
	"secondary": `styles_secondary__pcCPM`,
	"box": `styles_box__oLKNr`,
	"disabled": `styles_disabled__48Co-`,
	"active": `styles_active__7pg4D`,
	"horizontal": `styles_horizontal__oyEUh`,
	"vertical": `styles_vertical__XnSt6`,
	"selected": `styles_selected__wsqhu`,
	"primary": `styles_primary__xP7qj`,
	"smaller": `styles_smaller__wy-u9`,
	"triangle": `styles_triangle__QpJ3E`,
	"hidden": `styles_hidden__koNLT`,
	"row": `styles_row__RyKRU`,
	"openPlaceholder": `styles_openPlaceholder__IlR4j`,
	"absolute": `styles_absolute__jk-Pm`,
	"isBottom": `styles_isBottom__uHUbv`,
	"main": `styles_main__94UgV`,
	"minor": `styles_minor__Ef5Nk`
};
export default ___CSS_LOADER_EXPORT___;
